import ObservableModel from "util/ObservableModel";
import Annotation from "models/Annotation";
import User from "models/User";

export default ObservableModel.extend(
    {
        modelProperties: {
            annotations: Annotation,
            transcript: ObservableModel.extend({
                modelProperties: {
                    user: User,
                },
            }),
        },
        defaults: {
            annotations: [],
        },
    },
    function () {}
);
